import React from 'react';
import { Table } from '../../../components/table/Table';
import { useNavigation } from '@react-navigation/native';
import { TableHeader } from '../../../components/table/Headers';
import { AddButton } from '../../../components/button/AddButton';
import { useInvoke } from '../../../controllers/useInvoke';

export const PodcastsTable = (props) => {
    const {route: {params}} = props;
    const {row} = params || {};
    const website = row?._id;

    const navigation = useNavigation();

    const deleteInvoke = useInvoke({
        method: 'delete',
        eventSourceId: 'podcast',
    });

    return (
        <Table
            eventSourceId={["podcast"]}
            api={`/podcasts`}
            fields={{
                domain: {
                    domain: 1,
                },
                title: 1,
                podcast_url: 1,
                description: 1,
                time: 1,
            }}
            filter={{
                website,
            }}
            sort={{ index: 1 }}
            renderHeader={() => (
                <TableHeader
                    title="Podcasts"
                    actions={[
                        <AddButton
                            title="Add Podcast"
                            view="add-podcast"
                            params={{
                                website,
                            }}
                        />,
                    ]}
                />
            )}
            onRowPress={({ row }) => {
                navigation.navigate('edit-podcast', { row, website });
            }}
            columns={[
                {
                    type: 'text',
                    field: 'domain.domain',
                    header: 'Domain',
                    width: 120,
                },
                {
                    type: 'textArea',
                    field: 'title',
                    header: 'Title',
                },
                {
                    type: 'textArea',
                    field: 'description',
                    header: 'Description',
                },
                {
                    header: 'Podcast Link',
                    field: 'podcast_url',
                    type: 'textArea',
                },
                {
                    header: 'Time',
                    field: 'time',
                    align: 'center',
                    type: 'text',
                    width: 100,
                },
            ]}
            moreActions={() => [
                {
                    title: 'Edit',
                    onPress: ({ row }) => {
                        navigation.navigate('edit-podcast', { row, website });
                    },
                },
                {
                    title: 'Delete',
                    confirm: {
                        title: 'Delete',
                        message: 'Are you sure you want to Delete?',
                        confirmText: 'Delete',
                    },
                    onPress: ({ row }) => {
                        deleteInvoke({
                            uri: `/podcasts/${row?._id}`,
                            props: {},
                        });
                    },
                },
            ]}
        />
    );
};
